import axios from "../../../axios";
import Cookies from "js-cookie";

export const OrbitAdminLogin = async (
  email,
  password,
  keepMeLoggedIn = false,
) => {
  const payload = { email, password, keepMeLoggedIn };
  try {
    const response = await axios.post("/api/Auth/AdminLogin", payload, {
      headers: {
        "X-Public-Request": true,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || "Login Failed");
    } else {
      throw new Error("Network error or server unreachable");
    }
  }
};

export const VerifyAdminAccess = async () => {
  try {
    const token = Cookies.get("Orbit_Token");

    if (!token) {
      return { isAdmin: false };
    }

    const response = await axios.post(
      "/api/Auth/VerifyAdmin",
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("VerifyAdmin API error:", error);
    return { isAdmin: false };
  }
};
